<template>
  <v-row
    justify="center"
    v-bind="$attrs"
    data-aos="fade-right"
    align="center"
    style="position: relative;"
  >
    <!-- Left line -->
    <div
      v-if="line"
      class="primary step-line"
    ></div>

    <!-- Round number -->
    <v-col cols="12" class="text-center" align-self="end" style="z-index: 1">
      <v-avatar
        color="accent"
        size="52"
      >
        <span class="white--text headline">{{ number }}</span>
      </v-avatar>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "BaseStepNumber",
    props: {
      number: { type: Number },
      cols: { type: Number },
      line: { type: Boolean, default: false }
    }
  }
</script>

<style lang="scss" scoped>
.step-line {
  width: 50vw;
  height: 1px;
  position: absolute;
  bottom: 38px;
  right: 50%;
}
</style>